export default {
  ADD_AVISOS(state, avisos) {
    state.avisos = [...state.avisos, ...avisos]
  },
  SET_AVISOS(state, lista) {
    state.avisos = lista
  },
}
